import { WebStatus, LoginStrategy, DecisionResult, FastLoginOptions } from '../types'
import { parseClientParam } from '../parser'

/**
 * 核心决策引擎 (Mobile端)
 * 目前移动端暂未实现复杂的 App 唤起检测逻辑，
 * 主要逻辑是解析 URL 参数并结合 Web 登录态。
 */
export function decideMobileLoginStrategy(webStatus: WebStatus, options: FastLoginOptions = {}): DecisionResult {
  // 1. 获取 URL 参数中的指定账号信息
  // 移动端也可能通过 URL scheme 跳转唤起 Web，携带 _cl 参数
  const queryString =
    options.urlParams && typeof URLSearchParams !== 'undefined'
      ? new URLSearchParams(options.urlParams).toString()
      : typeof window !== 'undefined'
        ? window.location.search
        : ''

  const clientParam = parseClientParam(queryString)

  // 校验时间戳 (默认 30 分钟)
  const validityDuration = options.timestampValidityDuration ?? 30 * 60
  let isExpired = false

  if (clientParam && validityDuration > 0) {
    const now = Math.floor(Date.now() / 1000)
    if (now - clientParam.t > validityDuration) {
      isExpired = true
      console.warn(`[FastLoginSDK] Mobile _cl param expired. Timestamp: ${clientParam.t}, Now: ${now}`)
    }
  }

  const specifiedAccountId =
    !isExpired && (options.specifiedAccountId || clientParam?.i) ? options.specifiedAccountId || clientParam?.i : undefined

  // 移动端逻辑简化版：
  // 暂无 ClientStatus (App 安装检测比较复杂，暂不作为默认逻辑)

  if (specifiedAccountId) {
    // 有指定账号
    if (webStatus.isLoggedIn && webStatus.currentUser) {
      if (webStatus.currentUser.userid === specifiedAccountId) {
        return {
          strategy: LoginStrategy.MAINTAIN_WEB_LOGIN,
          data: { webAccount: webStatus.currentUser },
        }
      } else {
        // 账号不一致，构建一个临时的 clientAccount 用于展示冲突
        const targetClientAccount = {
          userid: specifiedAccountId,
          account: 'Unknown', // 移动端 _cl 通常不带 account 名，这里可能需要调整协议或接受未知
          source: 'mobile_client',
        }
        return {
          strategy: LoginStrategy.SHOW_CONFLICT_LOGIN,
          data: {
            webAccount: webStatus.currentUser,
            clientAccount: targetClientAccount,
            specifiedParam: clientParam || undefined,
          },
        }
      }
    } else {
      // Web 未登录，强制展示指定账号登录
      const targetClientAccount = {
        userid: specifiedAccountId,
        account: 'Unknown',
        source: 'mobile_client',
      }
      return {
        strategy: LoginStrategy.SHOW_SPECIFIED_LOGIN,
        data: {
          clientAccount: targetClientAccount,
          specifiedParam: clientParam || undefined,
        },
      }
    }
  }

  // 既没有本地客户端信息（暂不支持检测），也没有 URL 指定账号
  // 只能走普通登录
  return { strategy: LoginStrategy.NORMAL_LOGIN }
}
